import React, { createElement, ReactElement } from 'react'
import { Container } from '@kogk/common'
import { RawType, ImageType } from './types'
import { ParagraphSerializer } from './Elements/Paragraph'
import { ImageSerializer } from './Elements/Image'
import ReactDOMServer from 'react-dom/server'
export type HtmlSerializerProps = {
  raw: RawType[]
  imageType: ImageType
  linkResolver?: (page: string) => string
}

// We want to add all the list elements to the same ol or ul tag
let listElem: ReactElement | null = null
let oListElem: ReactElement | null = null

const richTextMapper = (
  element: RawType,
  imageType: ImageType,
  key: number,
  linkResolver?: (page: string) => string
) => {
  const { text, type } = element
  switch (type) {
    case 'heading1':
      return createElement('h1', { key }, text)
    case 'heading2':
      return createElement('h1', { key, className: 'h2' }, text)
    case 'heading3':
      return createElement('h3', { key }, text)
    case 'heading4':
      return createElement('h4', { key }, text)
    case 'heading5':
      return createElement('h5', { key }, text)
    case 'preformatted':
      return createElement('pre', { key }, text)
    case 'paragraph':
      return ParagraphSerializer(element, key, linkResolver)
    case 'list-item':
      if (!listElem) {
        listElem = createElement('ul', { key }, [])
      }
      listElem.props.children.push(ParagraphSerializer(element, key, linkResolver))
      return null
    case 'o-list-item':
      if (!oListElem) {
        oListElem = createElement('ol', { key }, [])
      }
      oListElem.props.children.push(ParagraphSerializer(element, key, linkResolver))
      return null
    case 'image':
      return ImageSerializer(element, imageType, key)
    default:
      return createElement('p', { key }, text)
  }
}

export const getHtmlString = (raw: RawType[], linkResolver?: (page: string) => string) => {
  const elems = getElems({ raw: raw, imageType: 'regular', linkResolver: linkResolver })
  return ReactDOMServer.renderToString(elems)
}

export const getElems = ({ raw, imageType, linkResolver }: HtmlSerializerProps) => {
  const elems: ReactElement[] = []
  for (let i = 0; i < raw.length; i++) {
    const elem = raw[i]

    if (listElem && (elem.type !== 'list-item' || i === raw.length - 1)) {
      elems.push(listElem)
      listElem = null
    }

    if (oListElem && (elem.type !== 'o-list-item' || i === raw.length - 1)) {
      elems.push(oListElem)
      oListElem = null
    }

    elems.push(richTextMapper(elem, imageType, i, linkResolver))
  }
  return <div className='article col-lg-8 offset-lg-2 p-0'>{elems.map(elem => elem)}</div>
}

const HtmlSerializer = ({ raw, imageType, linkResolver }: HtmlSerializerProps) => {
  const elems = getElems({ raw, imageType, linkResolver })
  return <Container className='page-slice-spacer'>{elems}</Container>
}
export default HtmlSerializer
